import MobileDisclimer from './MobileDisclimer';

export default MobileDisclimer;
